var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuExamples = function SvgMenuExamples(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.57 32.76"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Ebene 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 9.53 1.3 23.23 19.33-.44.21-23.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.06 4.72.08 3 15.63-.32.16 20.92 5.29-.24s0-23.94-.32-23.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.09.49v2.36l13.93-.16.08 18.72 4.48-.08V0z"
  })))));
};
export default SvgMenuExamples;